import { createSelector } from '@ngrx/store';
import { EntryCycleStatus, EntryCycleSubmissionHistoryView, EntryCyclesView, ParameterType, UserCaptureSourceRoleView } from '../../_generated';
import { DataEntryStore } from '../reducers/data-entry.reducer';
import { RootEntryCycles } from '../reducers/entry-cycles/entry-cycles.root.reducer';
import { getUserCaptureSourceRoles } from './auth.selector';
import { getDataEntryFeatureState } from './data-entry.selector';
import { getDataType } from './data-type.selector';
import RoleEnum = UserCaptureSourceRoleView.RoleEnum;

export const getEntryCyclesState = createSelector(getDataEntryFeatureState, (state) => state.entryCycles);

export const getEntryCyclesData = createSelector(getEntryCyclesState, (state: RootEntryCycles) => state.data);

export const getEntryCyclesRequestStatus = createSelector(getEntryCyclesState, (state: RootEntryCycles) => state.requestStatus);

export const getSelectedEntryCycle = createSelector(
  getEntryCyclesData,
  getDataEntryFeatureState,
  (entryCycles: EntryCyclesView[], state: DataEntryStore) => {
    if (state.selectedEntryCycleId === -1) {
      // If no entry cycle ID is selected, return the most recent active entry cycle
      let activeCycle: EntryCyclesView | undefined;
      for (let i = entryCycles.length - 1; i >= 0; i--) {
        if (entryCycles[i].status === EntryCycleStatus.active) {
          activeCycle = entryCycles[i];
          break;
        }
      }
      if (!activeCycle) {
        return undefined;
      }
      return activeCycle;
    } else {
      const selectedCycle = entryCycles.find((cycle) => cycle.id === Number(state.selectedEntryCycleId));
      if (!selectedCycle) {
        return undefined;
      }
      return selectedCycle;
    }
  },
);

export const getSelectedCycleParameterSubmissionHistory = createSelector(
  getSelectedEntryCycle,
  getDataType,
  (selectedEntryCycle: EntryCyclesView | undefined, dataType: ParameterType) => {
    return selectedEntryCycle?.entryCycleSubmissionHistory?.find((history: EntryCycleSubmissionHistoryView) =>
      history.submissionParameterType.includes(dataType),
    );
  },
);

export const getIsEntryCycleStatusReview = createSelector(
  getDataType,
  getSelectedEntryCycle,
  getUserCaptureSourceRoles,
  (dataType: ParameterType, selectedEntryCycle: EntryCyclesView | undefined, captureSourceRoles: UserCaptureSourceRoleView[]) => {
    const admin = captureSourceRoles.find((captureSourceRole) => captureSourceRole.role == RoleEnum.admin && captureSourceRole.code === dataType);

    return admin?.role !== RoleEnum.admin;
  },
);
